import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { searchProductAdvPlatform } from "@/api/dataAll/dataAll";
import { searchChannelToGameNoAccess } from "@/api/serchSelect";
import { mapState, mapActions } from "vuex";
import { getadvLocation } from "@/api/dataAll/advLocation";
import pickerOption from "@/mixins/module/pickerOption";
export default {
  mixins: [pickerOption],
  props: {
    propsData: Object,
    dataOptions: {
      type: String,
      default: function _default() {
        return "pickerOptionsRadius";
      }
    },
    kamitaku: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isDisabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      reqLoading: false,
      value2: [],
      productsList: [],
      advchannels: [],
      advLocation: [],
      Allchannel: [],
      searchCurrency: [],
      payChannel: [],
      searchData: {
        game_id: "",
        special_product_id: "",
        ad_channel: "",
        // 广告渠道
        ad_placement: "",
        //广告位置
        currency_info: "",
        pay_channel: "",
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      intReq: [],
      adPlacementSingleChoice: false,
      // 用于单选页面广告位置数据处理
      isDate: true,
      isProduct: true,
      adChannel: true,
      adPlacement: true,
      isCountry: true,
      isCurrency: false,
      isPayChannel: false,
      isTips: false,
      countryMultiple: true,
      optionType: {},
      MultipleOptions: true
    };
  },
  activated: function activated() {},
  created: function created() {
    var _this = this;

    for (var k in this.propsData) {
      this[k] = this.propsData[k];
    }

    this.getInit();
    this.$bus.$on("upd", function () {
      _this.getInit();
    });
    this.$bus.$on("updCurrency", function () {
      _this.searchData.currency_info = "";
      _this.searchCurrency = _this.$store.state.d2admin.serchSelect.searchCurrency;
    });

    if (this.isDate) {
      this.kamitaku ? this.defaultDate() : this.getsearchDate();
    }
  },
  watch: {
    searchCurrency: {
      deep: true,
      handler: function handler(newVal, oldVal) {
        this.$emit("currencyChange", newVal.length ? true : false);
      }
    },
    propsData: {
      deep: true,
      immediate: true,
      handler: function handler(newVal, oldVal) {
        for (var k in this.propsData) {
          this[k] = this.propsData[k];
        }
      }
    }
  },
  computed: _objectSpread({}, mapState("d2admin", {
    searchCountry: function searchCountry(state) {
      return state.serchSelect.searchCountry;
    },
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    },
    isreqCurrency: function isreqCurrency(state) {
      return state.serchSelect.isreqCurrency;
    },
    isreqPayList: function isreqPayList(state) {
      return state.serchSelect.isreqPayList;
    },
    isreqCountryList: function isreqCountryList(state) {
      return state.serchSelect.isreqCountryList;
    },
    szgmEnv: function szgmEnv(state) {
      return state.user.useryjenv;
    }
  })),
  methods: {
    getInit: function getInit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.intReq.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = item;

                            if (!_context.t0) {
                              _context.next = 4;
                              break;
                            }

                            _context.next = 4;
                            return _this2[item]();

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                _this2.optionType = _this2[_this2.dataOptions];
                _this2.searchData.ad_channel = "";
                _this2.searchData.ad_placement = "";
                _this2.searchData.currency_info = "";
                _this2.searchData.game_id = _this2.rawData.game_id;
                _this2.searchData.special_product_id = _this2.rawData.game_show_type == 2 ? _this2.rawData.id : [];
                _this2.advchannels = _this2.$store.state.d2admin.serchSelect.advchannels;

                if (!(_this2.$route.name !== 'index')) {
                  _context2.next = 18;
                  break;
                }

                if (_this2.isreqCurrency) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return _this2.$store.dispatch("d2admin/serchSelect/updCurrency", {
                  game_id: _this2.searchData.game_id,
                  special_product_id: _this2.searchData.special_product_id || ""
                });

              case 12:
                if (_this2.isreqPayList) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 15;
                return _this2.$store.dispatch("d2admin/serchSelect/getPayList");

              case 15:
                if (_this2.isreqCountryList) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 18;
                return _this2.$store.dispatch("d2admin/serchSelect/getCountryList");

              case 18:
                _this2.searchCurrency = _this2.$store.state.d2admin.serchSelect.searchCurrency;
                _this2.payChannel = _this2.$store.state.d2admin.serchSelect.payChannel;
                _this2.productsList = _this2.$store.state.d2admin.serchSelect.productsList;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getsearchDate: function getsearchDate() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var date = _this3.$times.timestampToTime(_this3.$times.zeroTimeZone() / 1000, 'YY-MM-DD');

        _this3.value2[0] = date;
        _this3.value2[1] = date;
        resolve([date, date]);
      });
    },
    // 上宅 默认时间
    defaultDate: function defaultDate() {
      var currentDate = this.$times.zeroTimeZone() / 1000;
      var aftDate = currentDate - 6 * 24 * 3600;
      var date = [this.$times.timestampToTime(aftDate, "YY-MM-DD"), this.$times.timestampToTime(currentDate, "YY-MM-DD")];
      this.value2 = date;
    },
    // 更新货币类型
    upCurrency: function upCurrency() {
      var _this4 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var data;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4.searchData.currency_info = "";
                  data = {
                    game_id: _this4.searchData.game_id || "",
                    ad_channel: _this4.searchData.ad_channel || "",
                    ad_placement: _this4.searchData.ad_placement || "",
                    special_product_id: _this4.searchData.special_product_id || ""
                  };
                  _context3.next = 4;
                  return _this4.$store.dispatch("d2admin/serchSelect/getCurrency", data);

                case 4:
                  _this4.searchCurrency = _context3.sent;
                  resolve();

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 更新支付类型
    upPayChannel: function upPayChannel() {
      var _this5 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var data;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this5.searchData.pay_channel = "";
                  data = {
                    game_id: _this5.searchData.game_id || "",
                    ad_channel: _this5.searchData.ad_channel || "",
                    ad_placement: _this5.searchData.ad_placement || "",
                    special_product_id: _this5.searchData.special_product_id || ""
                  };
                  _context4.next = 4;
                  return _this5.$store.dispatch("d2admin/serchSelect/getPayList", data);

                case 4:
                  _this5.payChannel = _context4.sent;
                  resolve();

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    productChange: function productChange(e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var ids;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ids = e.toString();
                _context5.next = 3;
                return _this6.upCurrency();

              case 3:
                if (!_this6.isPayChannel) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 6;
                return _this6.upPayChannel();

              case 6:
                _this6.getAdvPlarform(ids ? {
                  special_product_id: ids
                } : {
                  game_id: _this6.rawData.game_id
                });

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getAdvPlarform: function getAdvPlarform(data) {
      var _this7 = this;

      this.advchannels = [];
      this.advLocation = [];
      this.searchData.ad_channel = "";
      this.searchData.ad_placement = "";
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve, reject) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _this7.$store.dispatch("d2admin/serchSelect/getAdvPlarform", data);

                case 2:
                  _this7.advchannels = _context6.sent;
                  resolve(); // searchProductAdvPlatform(data).then((res) => {
                  //   if (res.status == 200) {
                  //     let list = res.data.findIndex((i) => i.adv_platform_mark == "default") == -1 ? [{ adv_platform_mark: "default", adv_platform_name: "默认", adv_place_data: [{ adv_place_mark: "default", adv_place_name: "默认" }] }, ...res.data] : res.data;
                  //     list.map(i=>{
                  //       i.adv_place_data.map(j=>{
                  //         j.adv_place_mark = j.adv_place_mark ? j.adv_place_mark :  'valuets'
                  //       })
                  //     })
                  //     this.advchannels = list
                  //     resolve();
                  //   }
                  // });

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x6, _x7) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    getAllchannel: function getAllchannel() {
      var _this8 = this;

      searchChannelToGameNoAccess({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this8.Allchannel = res.data;
        }
      });
    },
    // 选择广告位置
    advChannelchange: function advChannelchange(adv_platform_mark) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        _this9.searchData.ad_placement = "";
        _this9.advLocation = [];

        if (!adv_platform_mark) {
          resolve();
          return;
        }

        console.log(_this9.advchannels, adv_platform_mark);

        var index = _this9.advchannels.findIndex(function (item) {
          return item.adv_platform_mark == adv_platform_mark;
        });

        _this9.advLocation = _this9.advchannels[index].adv_place_data ? _this9.advchannels[index].adv_place_data : [];
        resolve();
      });
    },
    // 请求广告位置 （多选）
    advChannelchangeMore: function advChannelchangeMore(e) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var list, _iterator, _step, _loop;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this10.searchData.ad_placement = [];
                _this10.advLocation = [];
                list = [];
                _iterator = _createForOfIteratorHelper(e);

                try {
                  _loop = function _loop() {
                    var item = _step.value;
                    list = [].concat(_toConsumableArray(list), _toConsumableArray(_this10.advchannels.find(function (i) {
                      return i.adv_platform_mark == item;
                    }).adv_place_data ? _this10.advchannels.find(function (i) {
                      return i.adv_platform_mark == item;
                    }).adv_place_data : []));
                  };

                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _this10.advLocation = list.filter(function (item, index, selfArr) {
                  return selfArr.findIndex(function (x) {
                    return x.adv_place_mark === item.adv_place_mark;
                  }) === index;
                }); // this.upCurrency()

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    advPlacementchange: function advPlacementchange(e) {
      this.searchData.ad_placement = [e];
    },
    dataCleaning: function dataCleaning(value) {
      var _this11 = this;

      return new Promise(function (resolve, reject) {
        if (!value) {
          reject();
          return;
        }

        var t = false;
        var s = {
          game: "",
          platform: "",
          channel: "",
          pkg: ""
        };

        for (var key in s) {
          if (t) {
            _this11.searchData[key] = "";
          }

          if (value == key) {
            t = true;
          }
        }

        resolve();
      });
    }
  }
};